import {Inject, Injectable, Signal, signal} from "@angular/core";
import {ajs_$rootScope_DI_TOKEN, AjsRootScopeService} from "web-ng2/tjenester/ajs/AjsRootScopeService";
import {BasisKontroller} from "web/moduler/basis/BasisKontroller";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";

const debug = initDebugger('PresentasjonsmodusTjeneste');


/** Tjeneste som vedlikeholder tilstand om hvorvidt presentasjonsmodus er aktivert */
@Injectable({providedIn: 'root'})
export class PresentasjonsmodusTjeneste {

    private aktivert = signal(false);

    constructor(@Inject(ajs_$rootScope_DI_TOKEN) private ajsRootScopeService: AjsRootScopeService) {
    }

    get erAktivert(): Signal<boolean> {
        return this.aktivert.asReadonly();
    }

    settAktivert(aktivert: boolean) {
        if (aktivert) this.aktiver();
        else this.deAktiver();
    }

    aktiver() {
        debug('aktiverer presentasjonsmodus')
        this.aktivert.set(true);
        this.broadcastAjsEvent(BasisKontroller.eventer.presentasjonsmodusAktivert);

    }

    deAktiver() {
        debug('de-aktiverer presentasjonsmodus')
        this.aktivert.set(false);
        this.broadcastAjsEvent(BasisKontroller.eventer.presentasjonsmodusDeaktivert);
    }

    // private hjelpemetoder

    private broadcastAjsEvent(event: string) {
        this.ajsRootScopeService.$applyAsync(() => this.ajsRootScopeService.$broadcast(event));

    }
}
